import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const carriersAdapter = getAdapter({ idFieldName: 'text' });

const carriersSlice = createSlice({
  name: 'carriers',
  initialState: carriersAdapter.getInitialState(),
  reducers: {
    setCarriers: (state, { payload: { carriers } }) => {
      carriersAdapter.setAll(state, carriers);
    }
  }
});

const selectors = carriersAdapter.getSelectors(({ carriers }) => carriers);

export const getCarriers = state => selectors.selectAll(state);

export const { setCarriers } = carriersSlice.actions;

export default carriersSlice.reducer;
